module.exports = {
    Lang: {
        de: 'Tedesco',
        en: 'Inglese',
        es: 'Spagnolo',
        fr: 'Francese',
        pt: 'Portoghese',
        it: 'Italiano',
        ru: 'Russo'
    },
    Action: {
        add: 'Aggiungi',
        edit: 'Modifica',
        remove: 'Elimina ordine',
        close: 'Chiudi',
        select: 'Selezionare',
        save: 'Salva',
        saving: 'Sarà salvato',
        send: 'Inviare',
        confirmSelection: 'Confermare la selezione',
        change: 'Cambia',
        changeSelection: 'Cambia selezione',
        next: 'Successivo',
        prev: 'Precedente',
        finish: 'Concludi',
        'search': 'Cerca'
    },
    Common: {
        start: 'Iniziare',
        date: 'Data',
        creationdate: 'Data di creazione',
        lastmodified: 'Ultima modifica',
        status: 'Stato',
        color: 'Colore',
        settings: 'Impostazioni',
        masterdata: 'Dati master',
        masterdataSaved: 'I dati anagrafici sono stati salvati',
        amount: 'Importo',
        description: 'Descrizione',
        item: 'Articolo',
        itemNum: 'Articolo n.',
        itemName: 'Nome articolo',
        itemPrice: 'Prezzo dell`articolo',
        quantity: 'Quantità',
        singlePrice: 'Prezzo unitario',
        discount: 'Proprietà',
        rebate: 'Sconto',
        vat: 'IVA',
        total: 'Totale',
        orderPrice: 'Prezzo dell`ordine',
        annotation: 'Nota',
        accountDetails: 'Dati del cliente',
        customerNum: 'Cliente n.',
        salutation: 'Titolo',
        firstname: 'Nome',
        lastname: 'Cognome',
        company: 'Società',
        email: 'E-Mail',
        contact: 'Contatti',
        address: 'Via',
        postalcode: 'C.A.P.',
        city: 'Città',
        country: 'Nazione',
        taxDetails: 'Dati fiscali',
        vatId: 'P.IVA n.',
        noEntries: 'Nessuna voce',
        languageSettings: 'Imposta la lingua',
        showXtoYentries: 'Mostra da {x} a {y} risultati',
        showXtoYofZentries: 'Mostra {x} a {y} da {z} risultati',
        errorSavingMasterdata: 'Non è stato possibile salvare i dati anagrafici.',
        errorIncomplete: 'Forma incompleta',
        errorFieldMissing: '{field} deve essere compilato',
        errorUploadInvalidResp: 'Risposta del server non valida. Si prega di riprovare o di contattare il nostro supporto.'
    },
    Units: {
        C62: 'Pezzo',
        GRM: 'Grammo'
    },
    Dashboard: {
        title: 'Cruscotto'
    },
    Addresses: {
        title: 'Indirizzi',
        add: 'Nuovo indirizzo',
        addressMain: 'Indirizzo principale',
        addressBilling: 'Indirizzo di fatturazione',
        addressShipping: 'Indirizzo di consegna',
        confirmRemove: 'Volete davvero rimuovere il contatto?',
        errorLoad: 'Non è stato possibile caricare gli indirizzi.',
        errorRemove: 'L`indirizzo non può essere cancellato.'
    },
    EditAddress: {
        title: 'Nuovo indirizzo',
        errorTypeTitle: 'Si prega di definire un tipo di indirizzo.',
        errorTypeText: 'L`indirizzo deve essere un indirizzo di consegna e/o un indirizzo di fatturazione.',
        errorCreate: 'Non è stato possibile creare un indirizzo.',
        errorUpdate: 'L`indirizzo non può essere aggiornato.',
        shipping: 'Consegne',
        useForShippingNo: 'Non utilizzare come indirizzo di consegna',
        useForShippingYes: 'Utilizzo come indirizzo di consegna',
        useForShippingDefault: 'Utilizzo come indirizzo di consegna standard',
        billing: 'Fatture',
        useForBillingNo: 'Non utilizzare come indirizzo di fatturazione',
        useForBillingYes: 'Utilizzare come indirizzo di fatturazione',
        useForBillingDefault: 'Utilizzare come indirizzo di fatturazione predefinito'
    },
    Projects: {
        title: 'Report',
        loading: 'I rapporti sono caricati',
        currentProjects: 'Rapporti attuali',
        showAll: 'Visualizza tutti i rapporti',
        noProjects: 'Nessuna segnalazione',
        add: 'Nuovo report',
        projectNumber: 'Rapporto n.',
        projectName: 'ID Paziente',
        projectType: 'Tipo di report',
        statusAll: 'Tutti i rapporti',
        statusOpen: 'Rapporti aperti',
        statusOrdered: 'Rapporti ordinati',
        errorNoName: 'Si prega di specificare il nome del report.',
        errorCreate: 'Non è stato possibile creare un rapporto.',
        errorCouldNotLoad: 'Non è stato possibile caricare i rapporti'
    },
    ProjectDetails: {
        title: 'Dettagli dell`ordine',
        loading: 'Il rapporto è caricato',
        alertOrdered: 'Rapporto ordinato:',
        openOrder: 'Ordine aperto',
        alertReference: 'Questo progetto è collegato ad un altro progetto:',
        openProject: 'Rapporto aperto',
        toothSelection: 'Selezione dei denti',
        noConstruction: 'Keine Konstruktion festgelegt!',
        editConstruction: 'Kontruktion bearbeiten',
        materialSelection: 'Materialauswahl',
        estimatedDelivery: 'Vorauss. Lieferdatum',
        missingMaterial: 'Materialauswahl fehlt',
        missingAttachments: 'Allegati mancanti',
        addStl: 'STL hinzufügen',
        openCart: 'Al carrello',
        emptyCart: 'Carrello vuoto',
        shippingType: 'Metodo di spedizione',
        construction: 'Konstruktion',
        stlUpload: 'STL Upload',
        attachments: 'Allegati',
        addons: 'Prodotti supplementari',
        cart: 'Carrello',
        addItem: 'Aggiungi articolo',
        orderProject: 'Conferma l`ordine',
        statusNotOrdered: 'Non ancora ordinato',
        statusOrdered: 'Ordini',
        errorNoProjectnum: 'Nessun numero di rapporto valido trasferito'
    },
    Orders: {
        title: 'Ordini',
        loading: 'Gli ordini vengono caricati',
        currentOrders: 'Ordini in corso',
        openOrder: 'Ordine aperto',
        showAll: 'Mostra tutti gli ordini',
        noOrders: 'Nessun ordine',
        orderNum: 'Ordine n. ',
        projectRef: 'Rif. Progetto',
        statusAll: 'Tutti gli ordini',
        errorCouldNotLoad: 'Non è stato possibile caricare gli ordini'
    },
    Reports: {
        statusAll: 'Tutti i rapporti',
        statusReceived: 'Dati ricevuti',
        statusReceivedDescr: 'L`ordine verrà processato',
        statusInProgress: 'In lavorazione',
        statusInProgressDescr: 'L`ordine è in fase di elaborazione',
        statusInProduction: 'Modello di report pronto',
        statusInProductionDescr: 'Il vostro modello di rapporto viene creato',
        statusOnHold: 'Tenuta',
        statusCancelled: 'Cancellato',
        statusCancelledDescr: 'Il tuo ordine è stato cancellato',
        statusClosed: 'Report generato',
        statusCompleted: 'Report generato',
        statusCompletedDescr: 'L`ordine è stato completato',
        statusInvoicedCancelled: 'Teilberechnet / Storniert',
        statusPartlyDelivered: 'Teilgeliefert',
        statusPartlyDeliveredCancelled: 'Teilgeliefert / Storniert',
        statusPartlyDeliveredClosed: 'Teilgeliefert / Geschlossen',
        statusDelivered: 'Report generato',
        statusDeliveredDescr: 'Report generato',
        statusReadyForPickup: 'Pronto per il ritiro',
    },
    OrderDetails: {
        title: 'Dettagli dell`ordine',
        deliveryNote: 'Bolla di consegna',
        loading: 'L`ordine è stato caricato',
        trackingNum: 'Tracking N.',
        manufacturingStatus: 'Stato di produzione',
        trackingAndBilling: 'Tracciamento e fatturazione',
        creatingOrder: 'L`ordine viene creato',
        orderProject: 'Conferma l`ordine',
        placeOrder: 'Completa l`ordine',
        acceptTerms: 'Ho letto e accetto le <a href="{termsUrl}" target="_blank">condizioni generali di acquisto</a>.',
        errorNoOrderNum: 'Nessun numero d`ordine valido trasferito',
        errorCouldNotLoad: 'Non è stato possibile caricare l`ordine',
        priceNobleMetal1: 'Der Endgültige Produktpreis ist bei Edelmetallen vom endgültigen Gewicht abhängig.',
        priceNobleMetal2: 'Bitte prüfen Sie hierzu Ihren Lieferschein, sobald der Auftrag abgeschlossen ist.',
        files: 'File'
    },
    Messages: {
        title: 'Notizie',
        noMessages: 'Keine Nachrichten',
        errorCouldNotLoad: 'Nachrichten konnte nicht geladen werden',
        writeSomething: 'Schreiben Sie was...',
        errorSendingMessage: 'Nachricht konnte nicht gesendet werden.'
    },
    Configurator: {
        selectIndication: 'Indikation wählen',
        changeMaterial: 'Material ändern',
        selectTooth: 'Bitte wählen Sie einen Zahn',
        showToothNumbers: 'Zahnnummern anzeigen',
        toothSelection: 'Zahnauswahl',
        setProductProps: 'Produkteigenschaften festlegen',
        selectProduct: 'Produkt wählen',
        fileXofY: 'Datei {x} von {y}',
        calcPrice: 'Preise werden berechnet',
        uploadStl: 'STL hochladen',
        stlCount: 'Einheitenanzahl der obigen STL',
        stlCountTooltip: 'Bitte Einheitenanzahl der STL-Datei angeben, z.B. 3 Einheiten bei dreigliedriger Brücke',
        oneUnit: 'Eine Einheit',
        nUnits: '{n} Einheiten',
        removeJawSelection: 'Wollen sie die bestehende Auswahl in diesem Kiefer entfernen?',
        invalidTeethInRange: 'The {0} teeth is invalid for range {1}-{2}.',
        invalidRange: 'The {0}-{1} tooth range is invalid. The start/end teeth have to be on the same jaw.',
        invalidTeethNumber: 'The {0} is invalid teeth number.',
        transferSettings: 'Do you want to transfer those settings to multiple teeth?',
        clickOnConnectTooth: 'Click on the tooth you want to connect to'
    },
    Invoices: {
        title: 'Rechnungen',
        loading: 'Rechnungen werden geladen',
        invoiceNum: 'Rechnung Nr.',
        monthlyStatement: 'Monatsaufstellung',
        statusReceived: 'Ricevuto',
        statusOpen: 'Offen',
        statusHold: 'Gehalten',
        statusCancelled: 'Cancellato',
        statusClosed: 'Geschlossen',
        statusPartlyPaid: 'Teilbezahlt',
        statusPartlyPaidCancelled: 'Teilbezahlt / Storniert',
        statusPartlyPaidClosed: 'Teilbezahlt / Geschlossen',
        statusPaid: 'Bezahlt'
    },
    File: {
        name: 'Nome del file',
        hash: 'File hash',
        size: 'Dimensione file',
        messageUpload: 'Cliccare sul campo o trascinare il file nel campo',
        allFilesSameMaterial: 'Alle Dateien haben das gleiche Material',
        sendingData: 'I dati vengono trasmessi',
        processingData: 'I dati vengono elaborati',
        errorUpload: 'Si è verificato un errore. Il file non può essere caricato.',
        errorCouldNotList: 'Non è stato possibile caricare i file.',
        errorCouldNotLoad: 'Non è stato possibile caricare il file.',
        errorCouldNotDelete: 'Non è stato possibile rimuovere il file.'
    },
    Login: {
        username: 'E-mail o cliente n.',
        password: 'Password',
        passwordOld: 'Vecchia password',
        passwordNew: 'Nuova password',
        passwordConfirm: 'Conferma nuova password',
        passwordSaved: 'Password salvata',
        login: 'Login',
        logout: 'Logout',
        enterPwd: 'Si prega di inserire una password',
        invalidUserOrPwd: 'Nome utente o password non validi',
        errorCouldNotUpdate: 'Non è stato possibile salvare la password.',
        errorPasswordNoMatch: 'Le password non corrispondono.',
        errorOldPassword: 'La vecchia password è sbagliata.',
        errorNoSession: 'Nessuna sessione utente trovata. Effettuare il login.'
    }
};
